import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { styledHeaderText } from "../../styled";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: {
        text: styledHeaderText(t("addTmsService.dialogHeader", { ns: "dialogs" })),
        icon: "externalservice",
      },
      meta: {
        aliasLabel: t("addTmsService.serviceName", { ns: "dialogs" }),
        descriptionLabel: t("addTmsService.description", { ns: "dialogs" }),
        loaderLabel: t("addProxyService.imageForCatalog", { ns: "dialogs" }),
      },
      applyText: t("actions.create", { ns: "common" }),
      attributes: {
        addAttribute: t("addTmsService.addLayer", { ns: "dialogs" }),
        label: t("addTmsService.specifyLayers", { ns: "dialogs" }),
        description: t("addTmsService.layersHint", { ns: "dialogs" }),
        icon: "layers",
      },
    }),
    [t],
  );
};
